export class ImpersonationInfoModel {

    constructor() {}
    
    username : string;
    sourceUsername : string;
}